/**
 * The public address of the website. Canonical links, share previews and structured data all need a full address, and the
 * one the browser happens to be on is not always the right one (the www name, a preview link, an IP), so it is set once with
 * VITE_SITE_URL (apps/web/.env.production). With nothing set it is the address the page is on, which is right in development.
 */
export function siteUrl(): string {
  const set = import.meta.env.VITE_SITE_URL?.trim();
  const base = set || (typeof window !== 'undefined' ? window.location.origin : '');
  return base.replace(/\/+$/, '');
}

/** "/p/soy-candle" -> "https://meshsmith.in/p/soy-candle". The home page is "https://meshsmith.in/". */
export function absoluteUrl(path: string): string {
  const clean = path.split(/[?#]/)[0] ?? '';
  const p = clean.startsWith('/') ? clean : `/${clean}`;
  return `${siteUrl()}${p === '/' ? '/' : p.replace(/\/+$/, '')}`;
}

/** The picture shown when a page shared on WhatsApp, Facebook or X has none of its own. */
export const defaultShareImage = () => `${siteUrl()}/og-default.png`;
